export const fontSizes = [10, 12, 14, 16, 20, 24, 32, 40, 48, 64, 72];
export const lineHeights = ['18px', '22px', '26px', '34px', '40px', '50px'];
export const space = [0];



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/theme/scales.ts